import type { ReactNode } from "react";

type ProfileAccordionSectionProps = {
  id: string;
  icon: string;
  title: string;
  subtitle: string;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
};

export default function ProfileAccordionSection({
  id,
  icon,
  title,
  subtitle,
  open,
  onToggle,
  children,
}: ProfileAccordionSectionProps) {
  const panelId = `${id}-panel`;
  const buttonId = `${id}-button`;

  return (
    <section className={`user-profile-accordion${open ? " is-open" : ""}`}>
      <button
        type="button"
        id={buttonId}
        className="user-profile-accordion-trigger"
        aria-expanded={open}
        aria-controls={panelId}
        onClick={onToggle}
      >
        <span className="user-profile-accordion-icon" aria-hidden="true">
          <span className="material-symbols-outlined">{icon}</span>
        </span>
        <span className="user-profile-accordion-copy">
          <strong>{title}</strong>
          <small>{subtitle}</small>
        </span>
        <span
          className="material-symbols-outlined user-profile-accordion-chevron"
          aria-hidden="true"
        >
          expand_more
        </span>
      </button>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className="user-profile-accordion-panel"
        hidden={!open}
      >
        <div className="user-profile-accordion-content">{children}</div>
      </div>
    </section>
  );
}
